/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { Card } from 'primereact/card'
import { Button } from 'primereact/button'
import { useHistory } from 'react-router-dom'
import { getLoader } from '../_common/utils'
import NumberFormat from 'react-number-format'
import { userActions } from '../_actions'
function DashboardComponent({ castle, castleSummary, getCastle, getCastleSummary, saveCastle, isLoading }) {
  useEffect(() => {
    getCastle()
    getCastleSummary()
  }, [])
  const [errors, setErrors] = useState({})
  const history = useHistory()
  const [castleObject, setCastleObject] = useState(castle)
  function onTextChange(e) {
    const { name, value } = e.target
    setCastleObject(castleObject => ({ ...castleObject, [name]: value }))
  }
  const addCastle = () => {
    setErrors(castalMadatroy(castleObject))
  }
  function castleSummaryDetails(id) {
    history.push('/dashboard/company-list/summary/' + id)
  }
  function castalMadatroy(castleObject) {
    const errors = {}
    errors.hasError = false
    if (!castleObject?.large) {
      errors.large = 'Large Castles is Required'
      errors.hasError = true
    }
    if (!castleObject?.mediumFrom) {
      errors.midFrom = 'Midsize Castles From is Required'
      errors.hasError = true
    }
    if (!castleObject?.mediumTo) {
      errors.midTo = 'Midsize Castles To is Required'
      errors.hasError = true
    }
    if (!castleObject?.small) {
      errors.small = 'Small Castles is Required'
      errors.hasError = true
    }
    if (castleObject?.large < castleObject?.mediumTo) {
      errors.large = 'Large Castle value should be greater than the Midsize Castles To value'
      errors.hasError = true
    }
    if (castleObject?.small > castleObject?.mediumFrom) {
      errors.midFrom = 'Midsize Castles From should be greater than the Small Castles.'
      errors.hasError = true
    }
    if (castleObject?.mediumTo < castleObject?.mediumFrom) {
      errors.midTo = 'Midsize Castles To should be greater than the Midsize Castles From value.'
      errors.hasError = true
    }
    if (!errors.hasError)
      saveCastle(castleObject)
    return errors
  }
  useEffect(() => {
    const updatedBy = 'updatedBy'
    setCastleObject({ ...castle, [updatedBy]: userActions.getCurrentUser() })
  }, [castle, castleSummary])
  return (
    <div className="dashboard">
      <div className="dashboardContainer">
        <div className="dashboard--wrapper">
          <div className="dashboard--wrapper--introSec">
            <h4>DASHBOARD</h4>
            <p>Welcome to Wall Street Maps Administrator. From this page you can view a summary of the entire map database as well as edit basic map settings.</p>
          </div>
          {castleSummary ?
            <div className="dashboard--wrapper--introCard">
              <div className="holder" onClick={() => castleSummaryDetails(4)}>
                <h2>{parseInt(castleSummary.total)}</h2>
                <p>TOTAl COMPANIES</p>
              </div>
              <div className="holder" onClick={() => castleSummaryDetails(1)}>
                <h2>{castleSummary.large}</h2>
                <p>Large Companies</p>
              </div>
              <div className="holder" onClick={() => castleSummaryDetails(2)}>
                <h2>{castleSummary.medium}</h2>
                <p>Medium Companies</p>
              </div>
              <div className="holder" onClick={() => castleSummaryDetails(3)}>
                <h2>{castleSummary.small}</h2>
                <p>Small Companies</p>
              </div>
            </div> : ''}
          {castleObject ?
            <Card className="dashboard--wrapper--castleSec cardBase">
              <div className="p-grid m-0">
                <div className="p-col-12">
                  <h4 className="display_1 m-b-0">Castle Settings</h4>
                </div>
                <div className="p-col-6">
                  <span className="inputHolder">
                    <label className="inputHolder--label">Large Castles (greater than) <sup className="inputHolder--required">*</sup></label>
                    <NumberFormat className="inputHolder--inputBox" value={castleObject.large} onChange={onTextChange} name="large" />
                    {errors.large && (
                      <p className='space-danger'>{errors.large}</p>
                    )}
                  </span>
                </div>
                <div className="p-col-3">
                  <span className="inputHolder">
                    <label className="inputHolder--label">Midsize Castles (From - To) <sup className="inputHolder--required">*</sup></label>
                    <NumberFormat className="inputHolder--inputBox" placeholder="From (USD)" keyfilter="pint" value={castleObject.mediumFrom} name="mediumFrom" onChange={onTextChange} />
                    {errors.midFrom && (
                      <p className='space-danger'>{errors.midFrom}</p>
                    )}
                  </span>
                </div>
                <div className="p-col-3">
                  <span className="inputHolder">
                    <NumberFormat className="inputHolder--inputBox inputHolder--labelLess" placeholder="To (USD)" name="mediumTo" value={castleObject.mediumTo} onChange={onTextChange} />
                    {errors.midTo && (
                      <p className='space-danger'>{errors.midTo}</p>
                    )}
                  </span>
                </div>
                <div className="p-col-6">
                  <span className="inputHolder">
                    <label className="inputHolder--label">Small Castles (less than) <sup className="inputHolder--required">*</sup></label>
                    <NumberFormat className="inputHolder--inputBox" value={castleObject.small} name="small" onChange={onTextChange} />
                    {errors.small && (
                      <p className='space-danger'>{errors.small}</p>
                    )}
                  </span>
                </div>
                <div className="p-col-12 m-t-10">
                  <Button label="Save" className="p-button-raised p-button-rounded inputHolder--formBtn" onClick={addCastle} />
                </div>
              </div>
            </Card> : ''}
        </div>
      </div>
      {isLoading && getLoader()}
    </div>
  )
}

DashboardComponent.propTypes = {
  castle: PropTypes.object,
  castleSummary: PropTypes.object,
  getCastleSummary: PropTypes.func,
  getCastle: PropTypes.func,
  saveCastle: PropTypes.func,
  isLoading: PropTypes.bool
}
export default DashboardComponent
